import includes from 'lodash/includes';
const getExtension = fileName => {
  if (!fileName) {
    return null;
  }
  const i = fileName.lastIndexOf('.');
  if (i === -1 || i + 1 === fileName.length) {
    return null;
  }
  return fileName.substring(i + 1);
};
export function getReadableSize(size) {
  if (!size) {
    return '';
  }
  if (size < 1024 * 1024) {
    return `${Math.round(size / 1024)} kb`;
  }
  return `${Math.round(size / (1024 * 1024))} mb`;
}
export function isImage(contentType = '') {
  return contentType.indexOf('image') === 0;
}
export function isText(contentType = '') {
  return contentType.indexOf('text') === 0;
}
export function isVideo(contentType = '') {
  return contentType.indexOf('video') === 0;
}
export function isAudio(contentType = '') {
  return contentType.indexOf('audio') === 0;
}
export function isPDF(contentType = '') {
  return contentType === 'application/pdf';
}
export function isWord(contentType = '') {
  return contentType.indexOf('application/msword') === 0 || contentType.indexOf('application/vnd.ms-word') === 0 || contentType.indexOf('application/vnd.openxmlformats-officedocument.wordprocessingml') === 0;
}
export function isExcel(contentType = '') {
  return contentType.indexOf('application/vnd.ms-excel') === 0 || contentType.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml') === 0;
}
export function isGoogleSpreadsheet(contentType = '') {
  return contentType.indexOf('application/vnd.google-apps.spreadsheet') === 0;
}
export function isSpreadsheet(contentType = '') {
  return isExcel(contentType) || isGoogleSpreadsheet(contentType);
}
export function isPowerPoint(contentType = '') {
  return contentType.indexOf('application/vnd.ms-powerpoint') === 0 || contentType.indexOf('application/vnd.openxmlformats-officedocument.presentationml') === 0;
}
export function isXML(fileName, contentType = '') {
  return !!contentType.match(/(text|application)\/(.*\+)?xml/) || includes(['xml', 'html', 'xhtml', 'wsdl'], getExtension(fileName));
}
export function isArchive(fileName) {
  return includes(['zip', 'rar', 'gz', 'tgz', 'tar', 'ace', '7z', 'bz2'], getExtension(fileName));
}
export function isFolder(contentType = '') {
  return contentType.indexOf('application/vnd.google-apps.folder') === 0 || contentType.indexOf('application/vnd.box.folder') === 0;
}
export function getIcon(name, type) {
  if (isImage(type)) {
    return 'picture';
  }
  if (isPDF(type)) {
    return 'adobe-pdf';
  }
  if (isWord(type)) {
    return 'microsoft-word';
  }
  if (isSpreadsheet(type)) {
    return 'microsoft-excel';
  }
  if (isPowerPoint(type)) {
    return 'microsoft-powerpoint';
  }
  if (isArchive(name)) {
    return 'file-archive';
  }
  if (isFolder(type)) {
    return 'folder';
  }
  return 'file';
}